import React ,{useState} from 'react'
import {Offcanvas, Button, Row, Col, NavDropdown} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import {FiMenu} from 'react-icons/fi'
import Navs from './Navs'
function Sidebar({setSearch}) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button className="bg-light d-md-block d-lg-none text-secondary fs-4 border-0" style={{boxShadow:"none"}}onClick={handleShow}>
        <FiMenu />
      </Button>

      <Offcanvas className="w-75" show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Offcanvas</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
        <Row>
          <Link className="fs-3 text-secondary" as={Col} to="/">Home</Link>
          <Link className="fs-3 text-secondary" as={Col} to="/">Offers</Link>
{/* <NavDropdown title="Categories" id="basic-nav-dropdown" className="border-0 outline-0"> 
<NavDropdown.Item><Link className="fs-3 text-secondary" to="/products/watch" onClick={() => setSearch("watches")}>watch</Link></NavDropdown.Item>
<NavDropdown.Item><Link className="fs-3 text-secondary" to="/products/perfumes" onClick={() => setSearch("perfumes")}>perfumes</Link></NavDropdown.Item>
<NavDropdown.Item><Link className="fs-3 text-secondary" to="/products/toys" onClick={() => setSearch("toys")}>toys</Link></NavDropdown.Item>
<NavDropdown.Item><Link className="fs-3 text-secondary" to="/products/beauty" onClick={() => setSearch("beauty")}>beauty</Link></NavDropdown.Item>
<NavDropdown.Item><Link className="fs-3 text-secondary" to="/products/jewels" onClick={() => setSearch("jewels")}>jewels</Link></NavDropdown.Item>
<NavDropdown.Item><Link className="fs-3 text-secondary" to="/products/man" onClick={() => setSearch("man")}>man</Link></NavDropdown.Item>
<NavDropdown.Item><Link className="fs-3 text-secondary" to="/products/woman" onClick={() => setSearch("woman")}>woman</Link></NavDropdown.Item>
<NavDropdown.Item><Link className="fs-3 text-secondary" to="/products/kid" onClick={() => setSearch("kid")}>kids</Link></NavDropdown.Item>
<NavDropdown.Item><Link className="fs-3 text-secondary" to="/products/mobile" onClick={() => setSearch("mobile")}>mobiles</Link></NavDropdown.Item>
<NavDropdown.Item><Link className="fs-3 text-secondary" to="/products/electronic" onClick={() => setSearch("electronic")}>electronics</Link></NavDropdown.Item>
<Link className="fs-3 text-secondary" as={Col} to="/products">See All Categories</Link>
</NavDropdown> */}
          <Navs setSearch={setSearch} displayState="block"/>
          <Link className="fs-3 text-secondary" to="/about">About Us</Link>
          </Row>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
export default Sidebar